import { render, staticRenderFns } from "./DomainManage.vue?vue&type=template&id=0d400b89"
import script from "./DomainManage.vue?vue&type=script&lang=js"
export * from "./DomainManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports